module.exports = __webpack_public_path__ + "static/2nd-c4b756d84cde27b6d3ad0ae35999609d.png";